import { Box, Button, Grid, Typography } from "@mui/material";
import { NavLink, useSearchParams } from "react-router-dom";
import { translate } from "../../../translate/translate";

const NotFoundComponent = () => {
    const [searchParams] = useSearchParams();
    // Set by redirectToLoginHub (redirect-login-utils.tsx) when it couldn't
    // resolve a usable Hub login URL -- without this, the user landed here
    // with zero indication of why, and the "Início" button just bounced
    // them right back (this route requires no session, so it's the one
    // place safe to explain the failure and offer a way out).
    const isHubUrlUnavailable = searchParams.get("reason") === "hub_url_unavailable";

    return (
        <Box p={4}>
            <Grid container direction="column" alignItems="center" justifyContent="center" gap={2}>
                <Typography variant="h5">{translate.t("not_found")}</Typography>
                {isHubUrlUnavailable && (
                    <>
                        <Typography color="warning.main" textAlign="center">
                            {translate.t("hub_url_unavailable_message")}
                        </Typography>
                        <Button component={NavLink} to="/login" variant="outlined" color="primary">
                            {translate.t("local_fallback_login_link")}
                        </Button>
                    </>
                )}
                <Button component={NavLink} to="/" variant="contained" color="primary">
                    {translate.t("home")}
                </Button>
            </Grid>
        </Box>
    );
};

export default NotFoundComponent;
